export default "/_next/static/media/news-author-01.87ab487295350e0155ec78ee3811aed3.jpg";